import React from "react";
import MissionHarnessSection from "./mission/MissionHarnessSection";
import MissionPolicyFields from "../../Missions/MissionPolicyFields";
import { policyDraftFromEffectivePolicy, policyDraftFromPolicy } from "../../Missions/policy/missionPolicyDraft";
import { resolveMissionTemplatePolicy } from "./mission/missionTemplateDefaults";
import { listMissionTemplates } from "../../Missions/missionTemplatesApi";

export default function MissionTab({
  harnessEnabled,
  defaultMissionTemplateId,
  setDefaultMissionTemplateId,
  missionPolicyDraft,
  setMissionPolicyDraft,
  ...rest
}) {
  const templateId = defaultMissionTemplateId || "standard_agent";
  const [tenantTemplates, setTenantTemplates] = React.useState([]);

  React.useEffect(() => {
    let cancelled = false;
    listMissionTemplates()
      .then((items) => {
        if (!cancelled) setTenantTemplates(items);
      })
      .catch(() => {
        if (!cancelled) setTenantTemplates([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const policyForTemplate = React.useCallback(
    (id) => {
      const tenant = tenantTemplates.find((t) => t.id === id);
      if (tenant) return tenant.policy || {};
      return resolveMissionTemplatePolicy(id);
    },
    [tenantTemplates]
  );

  const handleTemplateChange = (id) => {
    setDefaultMissionTemplateId(id);
    setMissionPolicyDraft((draft) => ({
      ...draft,
      ...policyDraftFromPolicy(policyForTemplate(id)),
    }));
  };

  const handlePolicyChange = (key, value) => {
    setMissionPolicyDraft((draft) => ({ ...draft, [key]: value }));
  };

  const policyDisabled = !harnessEnabled;

  return (
    <>
      <MissionHarnessSection
        harnessEnabled={harnessEnabled}
        defaultMissionTemplateId={templateId}
        setDefaultMissionTemplateId={handleTemplateChange}
        tenantTemplates={tenantTemplates}
        {...rest}
      />
      {harnessEnabled && missionPolicyDraft && (
        <div
          className={
            policyDisabled
              ? "mission-harness__fields-disabled mission-harness__policy-stack"
              : "mission-harness__policy-stack"
          }
          aria-disabled={policyDisabled}
        >
          <MissionPolicyFields
            draft={missionPolicyDraft}
            onChange={handlePolicyChange}
            grouped
          />
        </div>
      )}
    </>
  );
}
